import React from "react";
import { Navigate } from "react-router-dom";

export default function TeamPage() {
  return <Navigate to="/#about" replace />;
}
